import { useLayoutEffect, useRef, useState } from "react";
import { KW_LAYOUT, STUDENT_GAP, kwTexts } from "@/lib/kwitansi";

const Txt = ({ pos, fs, children, testid }) => (
  <span data-testid={testid} style={{ position: "absolute", left: pos[0], top: pos[1] - fs, fontSize: fs, lineHeight: `${fs * 1.25}px`, whiteSpace: "nowrap", fontWeight: 400, color: "#141414", fontFamily: "Arial, Helvetica, sans-serif" }}>{children}</span>
);

const Check = ({ pos }) => (
  <svg style={{ position: "absolute", left: pos[0] - 9, top: pos[1] - 10 }} width="20" height="18" viewBox="0 0 20 18">
    <path d="M1 10 L6 16 L18 2" fill="none" stroke="#141414" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const KwitansiView = ({ data, school, testid = "kwitansi-view" }) => {
  const L = KW_LAYOUT[school === "sdqu" ? "sdqu" : "tk"];
  const t = kwTexts(data);
  const ref = useRef(null);
  const [scale, setScale] = useState(0.3);
  useLayoutEffect(() => {
    const el = ref.current;
    const ro = new ResizeObserver(() => { setScale(el.clientWidth / L.w); });
    ro.observe(el);
    return () => { ro.disconnect(); };
  }, [L.w]);
  return (
    <div ref={ref} data-testid={testid} className="w-full overflow-hidden rounded-xl shadow-md bg-white" style={{ height: L.h * scale }}>
      <div style={{ position: "relative", width: L.w, height: L.h, transform: `scale(${scale})`, transformOrigin: "top left" }}>
        <img src={L.bg} alt="Kwitansi" style={{ position: "absolute", inset: 0, width: L.w, height: L.h }} />
        {(t.from || t.student) && (
          <Txt pos={L.from} fs={L.fs} testid={`${testid}-from`}>
            {t.from}
            {t.student && <span data-testid={`${testid}-student`} style={{ fontWeight: 700, marginLeft: t.from ? STUDENT_GAP : 0 }}>{t.student}</span>}
          </Txt>
        )}
        {["no", "words", "sppText", "otherText", "date", "total"].map((k) => t[k] ? <Txt key={k} pos={L[k]} fs={L.fs} testid={`${testid}-${k}`}>{t[k]}</Txt> : null)}
        {data.spp && <Check pos={L.spp} />}
        {data.other && <Check pos={L.other} />}
        {data.pay_dev && <Check pos={L.dev} />}
        {data.uniform && <Check pos={L.uniform} />}
      </div>
    </div>
  );
};
